/**
 * The enum defining where a txp scenario was initialized from
 */
enum TxpSource {
    Unknown,
    MailReact,
    CalendarPeek,
    UpNext,
    CalendarForm,
    LoadingDialog,
    TagSetContainer,
    TimePanelPeek,
}

export default TxpSource;
